import React from 'react';

import { Tooltip } from 'antd';
import { DollarCircleOutlined } from '@ant-design/icons';

import { IToolbarCommand } from '../../../../../../../models/Shopping';

const CommandReprice: React.FunctionComponent<IToolbarCommand> = ({ disabled, action }) => {
    const _handleCommandAction = () => {
        if (disabled || !action) {
            return;
        }

        action();
    }

    return (
        <div className={`command ${disabled && 'command-disabled'}`} onClick={_handleCommandAction}>
            <Tooltip title="Reprice">
                <DollarCircleOutlined />
            </Tooltip>
        </div>
    );
}

export default CommandReprice;